/**
 * HAB Educational Page - Tabbed Content Section
 * Handles sticky nav, scroll-spy, header tracking, and tab switching.
 */
(function () {
  var SCROLL_OFFSET = 160;
  var HEADER_HEIGHT = 58;

  function initTabbedContent(section) {
    var nav = section.querySelector('.hab-edu-tabbed-nav');
    var sentinel = section.querySelector('.hab-edu-tabbed-sentinel');
    var segments = Array.from(section.querySelectorAll('.hab-edu-tabbed-progress-segment'));
    var labels = Array.from(section.querySelectorAll('.hab-edu-tabbed-label'));
    var cards = Array.from(section.querySelectorAll('.hab-edu-tabbed-card'));

    if (!nav || labels.length === 0 || cards.length === 0) {
      return;
    }

    var activeIndex = 0;
    var fixedHeader = document.querySelector('.hab-header-fixed');

    function setActiveTab(index) {
      if (index < 0 || index >= labels.length) {
        return;
      }

      activeIndex = index;

      labels.forEach(function (label, i) {
        label.classList.toggle('hab-edu-tabbed-label--active', i === index);
      });

      segments.forEach(function (segment, i) {
        segment.classList.toggle('hab-edu-tabbed-progress-segment--active', i <= index);
      });

      // Update progress bar gradient colors
      for (var s = 0; s < 4; s++) {
        nav.style.setProperty(
          '--seg' + (s + 1) + '-color',
          s <= index ? '#D9D9D9' : '#EEE'
        );
      }

      cards.forEach(function (card) {
        card.classList.remove('hab-edu-tabbed-card--hidden');
      });
    }

    // Tab click handler
    labels.forEach(function (label, i) {
      label.addEventListener('click', function () {
        setActiveTab(i);

        var card = cards[i];
        if (!card) {
          return;
        }
        var top = card.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // Header tracking - sticky nav follows fixed header show/hide
    function updateNavTop() {
      if (!fixedHeader) {
        return;
      }

      var transform = fixedHeader.style.transform;
      var match = transform.match(/translateY\(([-\d.]+)px\)/);
      var offset = match ? parseFloat(match[1]) : -HEADER_HEIGHT;
      var visibleHeight = Math.max(0, HEADER_HEIGHT + offset);
      nav.style.top = visibleHeight + 'px';
    }

    var navTicking = false;
    window.addEventListener('scroll', function () {
      if (navTicking) {
        return;
      }

      navTicking = true;
      requestAnimationFrame(function () {
        updateNavTop();
        navTicking = false;
      });
    });
    updateNavTop();

    // Scroll-spy
    var scrollSpyObserver = null;

    function setupScrollSpy() {
      if (scrollSpyObserver) {
        scrollSpyObserver.disconnect();
      }

      scrollSpyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }
            var index = cards.indexOf(entry.target);
            if (index === -1) {
              return;
            }
            setActiveTab(index);
          });
        },
        {
          rootMargin: '-20% 0px -60% 0px',
          threshold: 0,
        }
      );

      cards.forEach(function (card) {
        scrollSpyObserver.observe(card);
      });
    }

    // Sticky sentinel observer
    var stickyObserver = null;

    function setupStickyDetection() {
      if (stickyObserver) {
        stickyObserver.disconnect();
      }

      if (!sentinel) {
        return;
      }

      stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            nav.classList.toggle('hab-edu-tabbed-nav--stuck', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );

      stickyObserver.observe(sentinel);
    }

    // Handle resize
    var resizeTimer;
    function handleResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setupScrollSpy();
        setActiveTab(activeIndex);
      }, 150);
    }

    window.addEventListener('resize', handleResize);

    // Initialize
    setActiveTab(0);
    setupScrollSpy();
    setupStickyDetection();
  }

  function init() {
    var sections = document.querySelectorAll('.hab-edu-tabbed');
    sections.forEach(initTabbedContent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section.querySelector('.hab-edu-tabbed')) {
      initTabbedContent(section.querySelector('.hab-edu-tabbed'));
    }
  });
})();
